export default __webpack_public_path__ + "10914222b72bd75a9ecb3d4a2d92009e.png";